export const CHART_FONT_SIZE = 12;
export const CHART_HEIGHT = 250;
export const CHART_WIDTH = 300; // todo make dynamic
export const CHART_VERTICAL_MARGIN = 20;
export const CHART_HORIZONTAL_MARGIN = 25;
export const CHART_YLABELS_HORIZONTAL_MARGIN = 10;
export const CHART_BAR_WIDTH = 10;

export const CHART_TOOLTIP_HEIGHT = 70;
export const CHART_TOOLTIP_MARGIN = 6;
export const CHART_TOOLTIP_INNER_PADDING = 10;

export const CHART_TOOLTIP_BACKGROUND = 'brown';

export const CHART_LINE_COLOR = '#feb236';
export const CHART_BAR_COLOR = '#feb236';
